import React from "react";
import {
  Grid,
} from "@mui/material";
import { ContactRowDTO } from "./types"

export default function InstanceContactRow (entry: ContactRowDTO, bold = false) {
  const {rowEmail, rowFirst, rowLast} = entry;
  return (
    <>
      <Grid item xs={4} sx={{fontWeight: bold ? 'bold' : 'normal'}}>
        {rowFirst}
      </Grid>
      <Grid item xs={4} sx={{fontWeight: bold ? 'bold' : 'normal'}}>
        {rowLast}
      </Grid>
      <Grid item xs={4} sx={{fontWeight: bold ? 'bold' : 'normal'}}>
        {rowEmail}
      </Grid>
    </>
  );
}